import {get, post, put} from './Requester';

export function updateUser(user) {
    return put('users/' + user.id, user)
        .then(response => response.data);
}

export function getUser(id) {
    return get('users/' + id)
        .then(response => response.data);
}

export function createInvitedUser(user) {
    return post('register/accept-invitation', user)
        .then(response => response.data);
}

export function updateInvitedUser(user) {
    return put('users/' + user.id, user.data)
        .then(response => response.data);
}

export function postForgottenPassword(email) {
    return post('register/forgotten-password', {email})
        .then(response => response.data);
}

export async function getForgottenPassword(jwtToken) {
    const response = await get(`register/forgotten-password?jwtToken=${jwtToken}`, {checkAuthorization: false});
    return response.data;
}

export function postChangePassword(jwtToken, password) {
    return post('register/change-password', {jwtToken, password})
        .then(response => response.data);
}
